import React from 'react'
import { Field, ErrorMessage } from 'formik'


const TextArea = (props) => {
    const {label, name, ...rest } = props
    return (
        <div className="form-control">
            <label htmlFor={name}>{label}</label>
            <Field as='textarea' id={name} name={name} {...rest}/>
            <ErrorMessage name={name} className='error' />
        </div>
    )
}

export default TextArea
